import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { LanguageProvider } from "./contexts/LanguageContext";
import { UserProvider } from "./contexts/UserContext";
import "./index.css";
import theme from "./theme";

// Import polyfills - order matters!
import "./utils/EventsPolyfill";
import "./utils/NodePolyfills";

// More comprehensive process polyfill for the browser environment
// This helps libraries that expect Node.js environment variables and properties
if (typeof window !== "undefined") {
  // Provide process object if missing
  if (typeof window.process === "undefined") {
    window.process = {};
  }

  // Ensure process.env exists
  if (!window.process.env) {
    window.process.env = {};
  }

  // Add NODE_ENV
  window.process.env.NODE_ENV = import.meta.env.MODE || "development";

  // Add missing stdout properties
  window.process.stdout = window.process.stdout || {};
  window.process.stdout.isTTY = false;

  // Add missing stderr properties
  window.process.stderr = window.process.stderr || {};
  window.process.stderr.isTTY = false;

  // Add other properties that might be checked
  window.process.version = window.process.version || "v16.0.0";
  window.process.versions = window.process.versions || { node: "16.0.0" };
  window.process.platform = window.process.platform || "browser";

  // Add dummy methods that might be called
  window.process.on =
    window.process.on ||
    function () {
      return window.process;
    };
  window.process.addListener =
    window.process.addListener ||
    function () {
      return window.process;
    };
  window.process.once =
    window.process.once ||
    function () {
      return window.process;
    };
  window.process.off =
    window.process.off ||
    function () {
      return window.process;
    };
  window.process.removeListener =
    window.process.removeListener ||
    function () {
      return window.process;
    };
  window.process.removeAllListeners =
    window.process.removeAllListeners ||
    function () {
      return window.process;
    };
  window.process.emit =
    window.process.emit ||
    function () {
      return false;
    };
  window.process.nextTick =
    window.process.nextTick ||
    function (cb) {
      setTimeout(cb, 0);
    };
}

// Provide global object if missing
if (typeof global === "undefined") {
  window.global = window;
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <UserProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CssBaseline />
            <App />
          </LocalizationProvider>
        </UserProvider>
      </LanguageProvider>
    </ThemeProvider>
  </StrictMode>
);
